// src/features/tidsregistering/components/absence-planner/AbsenceSidebarCell.jsx
import React from 'react';
import { Badge, Box, useTheme } from '@mui/material';
import StaffMember from '../../../../components/common/StaffMember';

/**
 * Sidebar cell for one staff member row in the absence planner.
 * Shows: staff avatar + name (via StaffMember), with a badge for pending wish absences.
 *
 * Props injected by the renderLabel render-prop in CategorySidebar:
 *   category      — Category object (has .staffMember, .tasks)
 *   categoryHeight — px height of this row
 *   index         — row index
 */
export default function AbsenceSidebarCell({ category, categoryHeight }) {
  const theme = useTheme();
  const { staffMember, tasks = [] } = category;

  const pendingCount = tasks.filter(
    (slot) => slot.approvalState === 'approval_wish'
  ).length;

  return (
    <Box
      sx={{
        height: categoryHeight,
        display: 'flex',
        alignItems: 'center',
        px: 1.5,
        borderBottom: `1px solid ${theme.palette.divider}`,
        overflow: 'hidden',
      }}
    >
      <Badge
        badgeContent={pendingCount}
        color="warning"
        invisible={pendingCount === 0}
      >
        <StaffMember
          staffMember={staffMember}
          avatarSize={28}
          imageSize="32x32"
          gap={1}
          nameVariant="body2"
          nameSx={{ fontSize: 12, fontWeight: pendingCount > 0 ? 600 : 400, noWrap: true }}
        />
      </Badge>
    </Box>
  );
}
